import { createFileRoute } from "@tanstack/react-router";
import { AlcatrazTrialPage } from "@/components/solutions/AlcatrazTrialPage";
import { alcatrazTrialSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/solutions/alcatraz-dms_/trial")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => alcatrazTrialSeo(loaderData?.href ?? "/solutions/alcatraz-dms/trial"),
  component: AlcatrazTrialPage,
});
